var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"text-center"},[_c('v-btn',{staticClass:"btn-amnistie font-weight-bold",attrs:{"disabled":_vm.loading,"large":"","depressed":""},on:{"click":_vm.next}},[_vm._v("Suivant")])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }